import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6b4fdb00 = () => interopDefault(import('../pages/zapis/success.vue' /* webpackChunkName: "pages/zapis/success" */))
const _42d3a176 = () => interopDefault(import('../pages/zapis/error.vue' /* webpackChunkName: "pages/zapis/error" */))
const _ae6275ec = () => interopDefault(import('../pages/zapis/_slug/index.vue' /* webpackChunkName: "pages/zapis/_slug/index" */))
const _ca5fdde2 = () => interopDefault(import('../pages/zapis/index.vue' /* webpackChunkName: "pages/zapis/index" */))
const _1ffb80dc = () => interopDefault(import('../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _bc59f312 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _35a8f9c0 = () => interopDefault(import('../pages/vakansii/index.vue' /* webpackChunkName: "pages/vakansii/index" */))
const _811ea7c4 = () => interopDefault(import('../pages/uslugi/_slug/index.vue' /* webpackChunkName: "" */))
const _2e61d723 = () => interopDefault(import('../pages/uslugi/index.vue' /* webpackChunkName: "pages/uslugi/index" */))
const _52b9b180 = () => interopDefault(import('../pages/stat/_category/_article/index.vue' /* webpackChunkName: "pages/stat/_category/_article/index" */))
const _fde39d08 = () => interopDefault(import('../pages/stat/_category/index.vue' /* webpackChunkName: "pages/stat/_category/index" */))
const _0a10d3ae = () => interopDefault(import('../pages/stat/index.vue' /* webpackChunkName: "pages/stat/index" */))
const _627679b4 = () => interopDefault(import('../pages/specialists/components/SpecialistCard.vue' /* webpackChunkName: "pages/specialists/components/SpecialistCard" */))
const _2375b28b = () => interopDefault(import('../pages/specialists/components/Header/SpecialistHeader.vue' /* webpackChunkName: "pages/specialists/components/Header/SpecialistHeader" */))
const _e1619444 = () => interopDefault(import('../pages/specialists/index.vue' /* webpackChunkName: "" */))
const _954e42b4 = () => interopDefault(import('../pages/search/components/Articles.vue' /* webpackChunkName: "pages/search/components/Articles" */))
const _4d824642 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _7129f2bf = () => interopDefault(import('../pages/reviews/AddReviewModal.vue' /* webpackChunkName: "pages/reviews/AddReviewModal" */))
const _461f8c52 = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "pages/reviews/index" */))
const _9261e65a = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _2619b341 = () => interopDefault(import('../pages/questions-specialist/_question/index.vue' /* webpackChunkName: "pages/questions-specialist/_question/index" */))
const _739a58cb = () => interopDefault(import('../pages/questions-specialist/index.vue' /* webpackChunkName: "pages/questions-specialist/index" */))
const _c50c98ae = () => interopDefault(import('../pages/profile/zapis/index.vue' /* webpackChunkName: "pages/profile/zapis/index" */))
const _2b04e9ac = () => interopDefault(import('../pages/profile/my-acuvue/index.vue' /* webpackChunkName: "pages/profile/my-acuvue/index" */))
const _57f7320a = () => interopDefault(import('../pages/profile/edit/index.vue' /* webpackChunkName: "pages/profile/edit/index" */))
const _7f1b688b = () => interopDefault(import('../pages/profile/discount-card/_guid/index.vue' /* webpackChunkName: "pages/profile/discount-card/_guid/index" */))
const _59541c72 = () => interopDefault(import('../pages/profile/discount-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/index" */))
const _82c7eb88 = () => interopDefault(import('../pages/profile/certificates/index.vue' /* webpackChunkName: "pages/profile/certificates/index" */))
const _2df1773a = () => interopDefault(import('../pages/profile/bonuses/index.vue' /* webpackChunkName: "pages/profile/bonuses/index" */))
const _53589436 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _2610fac9 = () => interopDefault(import('../pages/product/test.vue' /* webpackChunkName: "pages/product/test" */))
const _6c4a2569 = () => interopDefault(import('../pages/product/glassesCardPage_v2.vue' /* webpackChunkName: "pages/product/glassesCardPage_v2" */))
const _99a50f3a = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _510b3dd1 = () => interopDefault(import('../pages/checkout/success.vue' /* webpackChunkName: "" */))
const _5be45e79 = () => interopDefault(import('../pages/order/payment/cancel/_hash.vue' /* webpackChunkName: "pages/order/payment/cancel/_hash" */))
const _7c8bbf48 = () => interopDefault(import('../pages/order/payment/_hash.vue' /* webpackChunkName: "pages/order/payment/_hash" */))
const _1a9e769b = () => interopDefault(import('../pages/checkout/process/_hash.vue' /* webpackChunkName: "" */))
const _407c6708 = () => interopDefault(import('../pages/ochki/_category/index.vue' /* webpackChunkName: "pages/ochki/_category/index" */))
const _4c7a2eae = () => interopDefault(import('../pages/ochki/index.vue' /* webpackChunkName: "pages/ochki/index" */))
const _c51d40fe = () => interopDefault(import('../pages/miopiya/indexOriginal.vue' /* webpackChunkName: "pages/miopiya/indexOriginal" */))
const _47eba4b6 = () => interopDefault(import('../pages/miopiya/components/QRList.vue' /* webpackChunkName: "pages/miopiya/components/QRList" */))
const _1a2da5f2 = () => interopDefault(import('../pages/miopiya/components/MiopiyaReasons.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaReasons" */))
const _c3ad6486 = () => interopDefault(import('../pages/miopiya/components/MiopiyaPrevention.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaPrevention" */))
const _4d5c6be0 = () => interopDefault(import('../pages/miopiya/index.vue' /* webpackChunkName: "pages/miopiya/index" */))
const _6bd3af16 = () => interopDefault(import('../pages/lenses/competitors/_slug.vue' /* webpackChunkName: "pages/lenses/competitors/_slug" */))
const _78031194 = () => interopDefault(import('../pages/lenses/_category/index.vue' /* webpackChunkName: "pages/lenses/_category/index" */))
const _02fb1c74 = () => interopDefault(import('../pages/lenses/index.vue' /* webpackChunkName: "pages/lenses/index" */))
const _1a18dce6 = () => interopDefault(import('../pages/information_message/informationMessage.vue' /* webpackChunkName: "pages/information_message/informationMessage" */))
const _65d837ba = () => interopDefault(import('../pages/company/questions/page.vue' /* webpackChunkName: "pages/company/questions/page" */))
const _71d63068 = () => interopDefault(import('../pages/company/questions/letterModal.vue' /* webpackChunkName: "pages/company/questions/letterModal" */))
const _24e4d2e8 = () => interopDefault(import('../pages/cms-page-preview/index.vue' /* webpackChunkName: "pages/cms-page-preview/index" */))
const _5c14c24e = () => interopDefault(import('../pages/checkout/process/new.vue' /* webpackChunkName: "pages/checkout/process/new" */))
const _477baa00 = () => interopDefault(import('../pages/checkout/process/index.vue' /* webpackChunkName: "pages/checkout/process/index" */))
const _bf7046c0 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _6cc70bcc = () => interopDefault(import('../pages/charity/_category/_article/index.vue' /* webpackChunkName: "pages/charity/_category/_article/index" */))
const _0fb56162 = () => interopDefault(import('../pages/charity/_category/index.vue' /* webpackChunkName: "pages/charity/_category/index" */))
const _79d18b14 = () => interopDefault(import('../pages/charity/index.vue' /* webpackChunkName: "pages/charity/index" */))
const _70043d2f = () => interopDefault(import('../pages/catalog/components/SelectedFilter.vue' /* webpackChunkName: "pages/catalog/components/SelectedFilter" */))
const _18233657 = () => interopDefault(import('../pages/catalog/components/FilterMobileComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterMobileComponent" */))
const _b1a73a4e = () => interopDefault(import('../pages/catalog/components/FilterComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterComponent" */))
const _0ce72bdb = () => interopDefault(import('../pages/catalog/components/ContactLinzCategory.vue' /* webpackChunkName: "pages/catalog/components/ContactLinzCategory" */))
const _3ff3211a = () => interopDefault(import('../pages/catalog/components/ArticleCard.vue' /* webpackChunkName: "pages/catalog/components/ArticleCard" */))
const _67dd36e2 = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _275f4055 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _6ff90bc2 = () => interopDefault(import('../pages/cart_old.vue' /* webpackChunkName: "pages/cart_old" */))
const _5c9f8864 = () => interopDefault(import('../pages/cart/checkout.vue' /* webpackChunkName: "pages/cart/checkout" */))
const _a3199420 = () => interopDefault(import('../pages/cart-old/done.vue' /* webpackChunkName: "pages/cart-old/done" */))
const _3a9e7240 = () => interopDefault(import('../pages/cart-old/basketPageThirdStep.vue' /* webpackChunkName: "pages/cart-old/basketPageThirdStep" */))
const _3a7474ba = () => interopDefault(import('../pages/cart-old/basketPageSecondStep.vue' /* webpackChunkName: "pages/cart-old/basketPageSecondStep" */))
const _df476758 = () => interopDefault(import('../pages/cart-old/index.vue' /* webpackChunkName: "pages/cart-old/index" */))
const _89728d0c = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _7ccc998f = () => interopDefault(import('../pages/bystraya-zapis/index.vue' /* webpackChunkName: "pages/bystraya-zapis/index" */))
const _69563bf5 = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _09fb5f68 = () => interopDefault(import('../pages/appointment/appointment.vue' /* webpackChunkName: "pages/appointment/appointment" */))
const _03141f5e = () => interopDefault(import('../pages/aktsii/_slug/index.vue' /* webpackChunkName: "pages/aktsii/_slug/index" */))
const _016cba63 = () => interopDefault(import('../pages/aktsii/index.vue' /* webpackChunkName: "pages/aktsii/index" */))
const _23d13b74 = () => interopDefault(import('../pages/acuvue/phoneRegistrationForm.vue' /* webpackChunkName: "pages/acuvue/phoneRegistrationForm" */))
const _2e8d8a26 = () => interopDefault(import('../pages/acuvue/index.vue' /* webpackChunkName: "pages/acuvue/index" */))
const _1f8db958 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/zapis/success",
    component: _6b4fdb00,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-success"
  }, {
    path: "/zapis/error",
    component: _42d3a176,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-error"
  }, {
    path: "/zapis/:slug",
    component: _ae6275ec,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-slug"
  }, {
    path: "/zapis",
    component: _ca5fdde2,
    pathToRegexpOptions: {"strict":true},
    name: "zapis"
  }, {
    path: "/wishlist",
    component: _1ffb80dc,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist"
  }, {
    path: "/video",
    component: _bc59f312,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/vakansii",
    component: _35a8f9c0,
    pathToRegexpOptions: {"strict":true},
    name: "vakansii"
  }, {
    path: "/uslugi/:slug/:service",
    components: {
      default: _811ea7c4
    }
  }, {
    path: "/uslugi/:slug",
    component: _811ea7c4,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi-slug"
  }, {
    path: "/uslugi",
    component: _2e61d723,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi"
  }, {
    path: "/stat/:category/:article",
    component: _52b9b180,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category-article"
  }, {
    path: "/stat/:category",
    component: _fde39d08,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category"
  }, {
    path: "/stat",
    component: _0a10d3ae,
    pathToRegexpOptions: {"strict":true},
    name: "stat"
  }, {
    path: "/specialists/components/SpecialistCard",
    component: _627679b4,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-SpecialistCard"
  }, {
    path: "/specialists/components/Header/SpecialistHeader",
    component: _2375b28b,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-Header-SpecialistHeader"
  }, {
    path: "/specialists/:id",
    components: {
      default: _e1619444
    }
  }, {
    path: "/specialists",
    component: _e1619444,
    pathToRegexpOptions: {"strict":true},
    name: "specialists"
  }, {
    path: "/search/components/Articles",
    component: _954e42b4,
    pathToRegexpOptions: {"strict":true},
    name: "search-components-Articles"
  }, {
    path: "/search",
    component: _4d824642,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/reviews/AddReviewModal",
    component: _7129f2bf,
    pathToRegexpOptions: {"strict":true},
    name: "reviews-AddReviewModal"
  }, {
    path: "/reviews",
    component: _461f8c52,
    pathToRegexpOptions: {"strict":true},
    name: "reviews"
  }, {
    path: "/registration",
    component: _9261e65a,
    pathToRegexpOptions: {"strict":true},
    name: "registration"
  }, {
    path: "/questions-specialist/:question",
    component: _2619b341,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist-question"
  }, {
    path: "/questions-specialist",
    component: _739a58cb,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist"
  }, {
    path: "/profile/zapis",
    component: _c50c98ae,
    pathToRegexpOptions: {"strict":true},
    name: "profile-zapis"
  }, {
    path: "/profile/my-acuvue",
    component: _2b04e9ac,
    pathToRegexpOptions: {"strict":true},
    name: "profile-my-acuvue"
  }, {
    path: "/profile/edit",
    component: _57f7320a,
    pathToRegexpOptions: {"strict":true},
    name: "profile-edit"
  }, {
    path: "/profile/discount-card/:guid",
    component: _7f1b688b,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-guid"
  }, {
    path: "/profile/discount-card",
    component: _59541c72,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card"
  }, {
    path: "/profile/certificates",
    component: _82c7eb88,
    pathToRegexpOptions: {"strict":true},
    name: "profile-certificates"
  }, {
    path: "/profile/bonuses",
    component: _2df1773a,
    pathToRegexpOptions: {"strict":true},
    name: "profile-bonuses"
  }, {
    path: "/profile",
    component: _53589436,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/product/test",
    component: _2610fac9,
    pathToRegexpOptions: {"strict":true},
    name: "product-test"
  }, {
    path: "/product/glassesCardPage_v2",
    component: _6c4a2569,
    pathToRegexpOptions: {"strict":true},
    name: "product-glassesCardPage_v2"
  }, {
    path: "/product/:slug?",
    component: _99a50f3a,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug"
  }, {
    path: "/order/success/:hash",
    components: {
      default: _510b3dd1
    }
  }, {
    path: "/order/payment/cancel/:hash?",
    component: _5be45e79,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-cancel-hash"
  }, {
    path: "/order/payment/:hash?",
    component: _7c8bbf48,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-hash"
  }, {
    path: "/order/:hash",
    components: {
      default: _1a9e769b
    }
  }, {
    path: "/ochki/:category",
    component: _407c6708,
    pathToRegexpOptions: {"strict":true},
    name: "ochki-category"
  }, {
    path: "/ochki",
    component: _4c7a2eae,
    pathToRegexpOptions: {"strict":true},
    name: "ochki"
  }, {
    path: "/miopiya/indexOriginal",
    component: _c51d40fe,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-indexOriginal"
  }, {
    path: "/miopiya/components/QRList",
    component: _47eba4b6,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-QRList"
  }, {
    path: "/miopiya/components/MiopiyaReasons",
    component: _1a2da5f2,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaReasons"
  }, {
    path: "/miopiya/components/MiopiyaPrevention",
    component: _c3ad6486,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaPrevention"
  }, {
    path: "/miopiya",
    component: _4d5c6be0,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya"
  }, {
    path: "/lenses/competitors/:slug?",
    component: _6bd3af16,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-competitors-slug"
  }, {
    path: "/lenses/:category",
    component: _78031194,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-category"
  }, {
    path: "/lenses",
    component: _02fb1c74,
    pathToRegexpOptions: {"strict":true},
    name: "lenses"
  }, {
    path: "/information_message/informationMessage",
    component: _1a18dce6,
    pathToRegexpOptions: {"strict":true},
    name: "information_message-informationMessage"
  }, {
    path: "/company/questions/page",
    component: _65d837ba,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-page"
  }, {
    path: "/company/questions/letterModal",
    component: _71d63068,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-letterModal"
  }, {
    path: "/cms-page-preview",
    component: _24e4d2e8,
    pathToRegexpOptions: {"strict":true},
    name: "cms-page-preview"
  }, {
    path: "/checkout/success",
    component: _510b3dd1,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-success"
  }, {
    path: "/checkout/process/new",
    component: _5c14c24e,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-new"
  }, {
    path: "/checkout/process/:hash",
    component: _1a9e769b,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-hash"
  }, {
    path: "/checkout/process",
    component: _477baa00,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process"
  }, {
    path: "/checkout",
    component: _bf7046c0,
    pathToRegexpOptions: {"strict":true},
    name: "checkout"
  }, {
    path: "/charity/:category/:article",
    component: _6cc70bcc,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category-article"
  }, {
    path: "/charity/:category",
    component: _0fb56162,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category"
  }, {
    path: "/charity",
    component: _79d18b14,
    pathToRegexpOptions: {"strict":true},
    name: "charity"
  }, {
    path: "/catalog/components/SelectedFilter",
    component: _70043d2f,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-SelectedFilter"
  }, {
    path: "/catalog/components/FilterMobileComponent",
    component: _18233657,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterMobileComponent"
  }, {
    path: "/catalog/components/FilterComponent",
    component: _b1a73a4e,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterComponent"
  }, {
    path: "/catalog/components/ContactLinzCategory",
    component: _0ce72bdb,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ContactLinzCategory"
  }, {
    path: "/catalog/components/ArticleCard",
    component: _3ff3211a,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ArticleCard"
  }, {
    path: "/catalog/*",
    component: _67dd36e2,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-all"
  }, {
    path: "/catalog",
    component: _275f4055,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/cart_old",
    component: _6ff90bc2,
    pathToRegexpOptions: {"strict":true},
    name: "cart_old"
  }, {
    path: "/cart/checkout",
    component: _5c9f8864,
    pathToRegexpOptions: {"strict":true},
    name: "cart-checkout"
  }, {
    path: "/cart-old/done",
    component: _a3199420,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-done"
  }, {
    path: "/cart-old/basketPageThirdStep",
    component: _3a9e7240,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageThirdStep"
  }, {
    path: "/cart-old/basketPageSecondStep",
    component: _3a7474ba,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageSecondStep"
  }, {
    path: "/cart-old",
    component: _df476758,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old"
  }, {
    path: "/cart",
    component: _89728d0c,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/bystraya-zapis",
    component: _7ccc998f,
    pathToRegexpOptions: {"strict":true},
    name: "bystraya-zapis"
  }, {
    path: "/authorization",
    component: _69563bf5,
    pathToRegexpOptions: {"strict":true},
    name: "authorization"
  }, {
    path: "/appointment/appointment",
    component: _09fb5f68,
    pathToRegexpOptions: {"strict":true},
    name: "appointment-appointment"
  }, {
    path: "/aktsii/:slug",
    component: _03141f5e,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii-slug"
  }, {
    path: "/aktsii",
    component: _016cba63,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii"
  }, {
    path: "/acuvue/phoneRegistrationForm",
    component: _23d13b74,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue-phoneRegistrationForm"
  }, {
    path: "/acuvue",
    component: _2e8d8a26,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue"
  }, {
    path: "/*",
    component: _1f8db958,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
